export default "__VITE_ASSET__5fd24473__"